import React, { useState, useRef, useEffect } from "react";
import { Button } from "Components/Button";
import KeyboardHint from "Components/KeyboardHint";
import InfoContentMotionWrapper from "Components/MotionWrapper/InfoContentMotionWrapper";
import { marketingStaffingData } from "Data";
import formStyles from "Styles/CompanySize.module.css";
import inputStyles from "Styles/Inputs.module.css";
import styles from "Styles/components/Dropdown.module.css";

const MarketingStaffingFormContent = ({
  submitCB = () => {},
  defaultValue = null,
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (defaultValue) {
      setSelectedValue(defaultValue);
    }
  }, [defaultValue]);

  const selectedOption = marketingStaffingData.find(
    (item) => item.value === selectedValue,
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (value) => {
    setSelectedValue(value);
    setIsOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitCB(selectedValue);
  };

  const renderLabel = (label) => {
    if (typeof label === "string" && label.includes("**")) {
      const parts = label.split(/(\*\*.*?\*\*)/g);
      return parts.map((part, i) => {
        if (part.startsWith("**") && part.endsWith("**")) {
          return <strong key={i}>{part.slice(2, -2)}</strong>;
        }
        return <span key={i}>{part}</span>;
      });
    }
    return label;
  };

  return (
    <InfoContentMotionWrapper>
      <div className={formStyles.content}>
        <fieldset className={inputStyles.fieldset}>
          <legend className={inputStyles.legend}>單選題</legend>
          <form className={inputStyles.form} onSubmit={handleSubmit}>
            <div className={styles.dropdownWrapper} ref={dropdownRef}>
              <button
                type="button"
                className={`${styles.dropdownTrigger} ${isOpen ? styles.open : ""} ${selectedValue ? styles.hasValue : ""}`}
                onClick={() => setIsOpen(!isOpen)}
              >
                <span className={selectedValue ? "" : styles.placeholder}>
                  {selectedOption
                    ? renderLabel(selectedOption.label)
                    : "你的角色"}
                </span>
                <svg
                  className={styles.arrow}
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M9.50595 14.7408C9.561 14.8207 9.63465 14.8861 9.72058 14.9313C9.8065 14.9764 9.90212 15 9.99919 15C10.0963 15 10.1919 14.9764 10.2778 14.9313C10.3637 14.8861 10.4374 14.8207 10.4924 14.7408L15.8928 6.94134C15.9554 6.85138 15.992 6.74601 15.9988 6.63668C16.0057 6.52735 15.9824 6.41825 15.9315 6.32121C15.8807 6.22418 15.8042 6.14294 15.7105 6.08631C15.6167 6.02968 15.5092 5.99983 15.3996 6H4.59876C4.48946 6.00045 4.38235 6.03069 4.28895 6.08745C4.19555 6.14422 4.11939 6.22537 4.06866 6.32217C4.01794 6.41898 3.99457 6.52778 4.00106 6.63688C4.00756 6.74597 4.04367 6.85123 4.10553 6.94134L9.50595 14.7408Z"
                    fill="black"
                  />
                </svg>
              </button>

              {isOpen && (
                <div className={styles.dropdownMenu}>
                  {marketingStaffingData.map((item) => (
                    <div
                      key={item.value}
                      className={`${styles.dropdownOption} ${selectedValue === item.value ? styles.selected : ""}`}
                      onClick={() => handleSelect(item.value)}
                    >
                      <span className={styles.optionLabel}>
                        {renderLabel(item.label)}
                      </span>
                      {selectedValue === item.value && (
                        <svg
                          className={styles.checkmark}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M14.8965 5.00347C15.1318 4.78263 15.4437 4.66183 15.7664 4.66657C16.089 4.6713 16.3972 4.8012 16.6259 5.02886C16.8546 5.25651 16.986 5.56411 16.9922 5.88675C16.9984 6.20939 16.8791 6.52183 16.6593 6.75815L9.98066 14.9899C9.86596 15.1117 9.72788 15.2091 9.57467 15.2764C9.42146 15.3436 9.25627 15.3792 9.08898 15.3811C8.92168 15.383 8.75572 15.3512 8.60102 15.2875C8.44632 15.2238 8.30605 15.1295 8.1886 15.0104L3.82987 10.5892C3.70842 10.4744 3.61134 10.3363 3.54442 10.1832C3.4775 10.0301 3.4421 9.86505 3.44034 9.69795C3.43858 9.53086 3.4705 9.36512 3.53418 9.21062C3.59787 9.05613 3.69202 8.91604 3.81102 8.79872C3.93002 8.68141 4.07143 8.58926 4.22681 8.52778C4.3822 8.4663 4.54837 8.43674 4.71543 8.44088C4.88248 8.44502 5.04699 8.48276 5.19914 8.55185C5.3513 8.62095 5.48797 8.71998 5.60102 8.84305L9.05046 12.3402L14.8647 5.03974C14.8752 5.02704 14.8864 5.01494 14.8982 5.00348L14.8965 5.00347Z"
                            fill="#1754E7"
                          />
                        </svg>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div style={{ display: "flex", alignItems: "end", gap: "0.75rem" }}>
              <Button disabled={!selectedValue} marginTop type="action" submit>
                OK
              </Button>
              <KeyboardHint />
            </div>
          </form>
        </fieldset>
      </div>
    </InfoContentMotionWrapper>
  );
};

export default MarketingStaffingFormContent;
